export default __webpack_public_path__ + "static/media/reveal.7b708421.png";